/* Add salt for a form */
;
(function () {
    const $form = $('.js-m-salt');
    if (!$form.length) return false;

    var input = $('<input type="hidden" name="salt" value="true">');
    $form.append(input);
})();